import { c as _c } from "react/compiler-runtime";
import Icon from './Icon';
import DropdownMenu from './DropdownMenu';
import useElementWidth from './hooks/useElementWidth';
type SearchSelectProps = {
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  children: React.ReactNode;
  disabled?: boolean;
  placeholder?: string;
};
export default function SearchSelect(t0) {
  const $ = _c(15);
  const {
    value,
    onChange,
    children,
    disabled,
    placeholder
  } = t0;
  const [inputContainerRef, inputContainerWidth] = useElementWidth();
  const t1 = `${inputContainerWidth}px`;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      minWidth: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== disabled || $[3] !== onChange || $[4] !== placeholder || $[5] !== value) {
    t3 = <input value={value} onChange={onChange} disabled={disabled} placeholder={placeholder} className="focus:outline-hidden flex-1" />;
    $[2] = disabled;
    $[3] = onChange;
    $[4] = placeholder;
    $[5] = value;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon size="sm" name="selector" className="text-gray-400" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== inputContainerRef || $[9] !== t3) {
    t5 = <div ref={inputContainerRef} className="rounded-xs flex w-full border border-gray-300 px-4 py-2 text-sm text-gray-900">{t3}{t4}</div>;
    $[8] = inputContainerRef;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== children || $[12] !== t2 || $[13] !== t5) {
    t6 = <DropdownMenu content={children} style={t2}>{t5}</DropdownMenu>;
    $[11] = children;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}